// ## context provider on the top level of PIM to manage the required data of the PIM
import React, { createContext, useContext, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';

export const StateContext = createContext(null);

export default function DAMModuleStateProvider({ children }) {
  const reducerState = useSelector((redState) => redState);
  const {
    Users: { logInRights },
  } = reducerState;

  const initialSetting = {
    cardList: [],
    selectedIdArray: [],
    archivedList: [],
  };
  const [Damstate, setDAMState] = useState(initialSetting);

  const { CheckActionPermission } = useComponent();

  const damAddEditAccess = CheckActionPermission(logInRights, 'dam', 'all', 'addEdit');

  const damDeleteAccess = CheckActionPermission(logInRights, 'dam', 'all', 'delete');
  const contextValue = useMemo(() => {
    return { Damstate, setDAMState, damAddEditAccess, damDeleteAccess };
  }, [setDAMState, Damstate, damAddEditAccess, damDeleteAccess]);

  return <StateContext.Provider value={contextValue}>{children}</StateContext.Provider>;
}

export function useDAMModuleState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the DAMModule State Provider');
  }
  return context;
}
